import { useEffect } from 'react'

import OrdersTemplate from 'Components/UI/Templates/Sales/Orders'

const Orders = () => {
  useEffect(() => {
    document.title = 'Pedidos'
  }, [])

  return <OrdersTemplate />
}

export default Orders
